import { __exportAll } from "../../../_virtual/_rolldown/runtime.js";
import { createElementBlock, createElementVNode, openBlock } from "vue";
//#region src/components/ScalarIcon/logos/Platformatic.svg?component
var Platformatic_exports = /* @__PURE__ */ __exportAll({
	default: () => Platformatic_default,
	render: () => render$1
});
var _hoisted_1 = {
	xmlns: "http://www.w3.org/2000/svg",
	fill: "none",
	viewBox: "0 0 24 24"
};
function render$1(_ctx, _cache) {
	return openBlock(), createElementBlock("svg", _hoisted_1, [..._cache[0] || (_cache[0] = [createElementVNode("path", {
		stroke: "#21FA90",
		"stroke-linecap": "round",
		"stroke-linejoin": "round",
		d: "M5.038 13.757v3.814m1.496-4.566 3.04 1.761 4.534-2.627V6.885L9.574 4.258 5.038 6.885v4.56m1.496 1.56v1.668m0-1.668 1.49-.91"
	}, null, -1), createElementVNode("path", {
		stroke: "#00050B",
		"stroke-linecap": "round",
		"stroke-linejoin": "round",
		"stroke-width": ".885",
		d: "m21.719 10.719 1.839 1.09v1.09l-1.84 1.091M2.834 8.13.774 9.322v5.326l2.016 1.167m3.744 1.07v1.183l3.021 1.674 2.32-1.358-.02-2.471m2.282-1.387v1.3L16.31 17.1l3.175-1.9v-5.186L16.36 8.217"
	}, null, -1)])]);
}
var Platformatic_default = { render: render$1 };
//#endregion
export { Platformatic_exports, Platformatic_default as default, render$1 as render };

//# sourceMappingURL=Platformatic.svg.virtual.js.map